 angular
     .module('vppApp')
     .factory('AccountDetailsService', function() {

         var AccountDetailsService = {
             firstName: "",
             lastName: "",
             streetAddress: "",
             city: "",
             stateInclPR: "",
             postalCode: "",
             dateOfBirth: "",
             phoneNumber: "",
             emailAddress: ""
         };

         return AccountDetailsService;

     });
